export default defineNuxtRouteMiddleware(async (to) => {
	const runtimeConfig = useRuntimeConfig()
	if (runtimeConfig.public.environment === "component_test" || to.path.startsWith("/api/auth")) return

	const { loggedIn } = useUserSession()

	if (loggedIn.value === false) {
		try {
			await navigateTo("/api/auth/keycloak", { external: true })
		} catch (error: unknown) {
			createError(error as Error)
		}
	}
})
